import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76af27b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-top" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "card-top-info" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "card-top-info-nickname" }
const _hoisted_8 = { class: "card-top-info-number" }
const _hoisted_9 = { class: "card-links" }

import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'
import avatar from '@/assets/images/header.jpg'


export default /*#__PURE__*/_defineComponent({
  __name: 'userCard',
  setup(__props) {

const linkList = [
  {
    icon: 'icon-lesson',
    title: '我的课程',
    url: '/lesson'
  },
  {
    icon: 'icon-order',
    title: '订单中心',
    url: '/order'
  },
  {
    icon: 'icon-integral',
    title: '积分商场',
    url: '/integral'
  },
  {
    icon: 'icon-setting',
    title: '个人设置',
    url: '/user'
  }
]
const store = useStore()
const userInfo = computed(() => {
  return store.getters.userInfo
})
const handleLogoutClick = async () => await store.dispatch('user/logout')

defineComponent({
  name: 'UserCard'
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(avatar),
        alt: "图像",
        height: "72",
        width: "72"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", _hoisted_5, _toDisplayString(userInfo.value.name), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(userInfo.value.email), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(userInfo.value.nickname), 1),
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("span", null, "经验：" + _toDisplayString(userInfo.value.experience), 1),
          _createElementVNode("span", null, "积分：" + _toDisplayString(userInfo.value.points), 1)
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_9, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(linkList, (item, index) => {
        return _createElementVNode("li", {
          key: index,
          class: "card-links-item"
        }, [
          _createVNode(_component_router_link, {
            to: item.url
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(['iconfont', item.icon])
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ])
      }), 64))
    ]),
    _createVNode(_component_el_divider),
    _createElementVNode("div", {
      class: "card-exit",
      onClick: handleLogoutClick
    }, "安全退出")
  ]))
}
}

})